import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../App.vue'
import CTank from '../views/e-tank.vue'
Vue.use(VueRouter)

const routes = [
  {
        path: '/',
        name: 'home',
        component: HomeView,
        redirect: '/en'
  },
  {
    path: '/chs',
    name: 'chs',
    component: () => import(/* webpackChunkName: "about" */ '../views/c-tank.vue'),
    meta:{
      title:'巅峰坦克：装甲战歌官网 满足你对战争的一切想象'
    }
  },
  {
    path: '/en',
    name: 'en',
    component: () => import(/* webpackChunkName: "about" */ '../views/e-tank.vue'),
    meta:{
      title:'Clash of Panzer: Tank Battle    Meet All Your Expectations About Warfare'
    },
    children: [
      {
        path: 'privacy_en',
        name: 'privacy_en',
        component: () => import('../components/privacyEn.vue')
      },
      {
        path: 'per_sdk_en',
        name: 'per_sdk_en',
        component: () => import('../components/TermsServiceEn.vue')
      }
    ]
  },
  {
    path: '/rus',
    name: 'rus',
    component: () => import(/* webpackChunkName: "about" */ '../views/r-tank.vue'),
    meta:{
      title:'Первенство танков: Официальный сайт《Песни брони》  удовлетворяет вашему воображению войны '
    },
    children: [
      {
        path: 'privacy_en',
        name: 'privacy_en',
        component: () => import('../components/privacyEn.vue')
      },
      {
        path: 'per_sdk_en',
        name: 'per_sdk_en',
        component: () => import('../components/TermsServiceEn.vue')
      }
    ]
  },
  {
    path: '/cht',
    name: 'cht',
    component: () => import(/* webpackChunkName: "about" */ '../views/t-tank.vue'),
    meta:{
      title:'巔峰坦克：裝甲戰歌官網 滿足你對戰爭的一切想像'
    },
    children: [
      {
        path: 'privacy_cht',
        name: 'privacy_cht',
        component: () => import('../components/privacyCht.vue')
      },
      {
        path: 'per_sdk_cht',
        name: 'per_sdk_cht',
        component: () => import('../components/TermsServiceCht.vue')
      }
    ]
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../components/news.vue'),
    children: [
      {
        path: ':id',
        name: 'newscontent',
        component: () => import('../components/newsContent.vue')
      }
    ]
  },   
  {
    path: '/m-en',
    name: 'm-en',
    component: () => import(/* webpackChunkName: "about" */ '../views/m/c-tank.vue'),
    meta:{
      title:'Clash of Panzer: Tank Battle    Meet All Your Expectations About Warfare'
    }
  },
  {
    path: '/m-rus',
    name: 'm-rus',
    component: () => import(/* webpackChunkName: "about" */ '../views/m/r-tank.vue'),
    meta:{
      title:'Первенство танков: Официальный сайт《Песни брони》  удовлетворяет вашему воображению войны '
    }
  },
  {
    path: '/m-cht',
    name: 'm-cht',
    component: () => import(/* webpackChunkName: "about" */ '../views/m/t-tank.vue'),
    meta:{
      title:'巔峰坦克：裝甲戰歌官網 滿足你對戰爭的一切想像'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
